export default __webpack_public_path__ + "images/17d75211892dcba0b37bafa3fdac1793-baby.jpg";